<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div style></div>
        <h5 class="vue-title">
          <strong>{{ $t("CREATEUSER") }}</strong>
        </h5>
        <br />
        <b-form class="formTextSize" @submit.prevent="gotoCreate">
          <b-row>
            <b-col md="3" sm="4">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("USERID") }}
                  <span class="mandotry-color">*</span>
                </span>
                <b-form-input
                  v-model.trim="$v.userForm.userid.$model"
                  class="inputField"
                  type="text"
                  autocomplete="name"
                  :maxlength="CONSTANTS.default"
                ></b-form-input>
                <show-errors :control="$v.userForm.userid" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>

            <b-col md="3" sm="4">
              <b-form-group id="addressField" label-for="input-1">
                <span>
                  {{ $t("BIRTHDATE") }}
                  <span class="mandotry-color">*</span>
                </span>
                <date-picker
                  :lang="lang"
                  class="datePickerCss"
                  :disabled-date="notBeforeDate"
                  :placeholder="$t('BIRTHDATE')"
                  v-model.trim="$v.userForm.dob.$model"
                  :editable="true"
                  valuetype="YYYY:MM:DD"
                  :default-value="this.userForm.dob"
                ></date-picker>
                <show-errors :control="$v.userForm.dob" :field="$t('MANDATORY')" />
              </b-form-group>
            </b-col>
            <b-col md="2" class="textCenterMedia">
              <button
                type="button"
                class="btn btn-primary paddingMediaQry"
                @click="success"
              >{{ $t("NEXT") }}</button>
            </b-col>
            <b-col sm="2"></b-col>
          </b-row>
          <br />
        </b-form>

        <br />
        <b-modal id="modal-Status-create" hide-footer>
          <template v-slot:modal-title>{{ $t("USERCREATION") }}</template>
          <p>{{ $t("WANTTOCREATE") }}?</p>
          <hr />
          <b-row>
            <b-col>
              <b-button
                variant="outline-primary"
                size="sm"
                class="buttons-align-right"
                type="submit"
              >{{ $t("SUBMIT") }}</b-button>

              <b-button
                variant="outline-secondary"
                size="sm"
                class="buttons-align-right"
                @click="$bvModal.hide('modal-Status-create')"
              >{{ $t("CANCEL") }}</b-button>
            </b-col>
          </b-row>
        </b-modal>

        <br />
      </div>
    </div>
  </div>
</template>

<script>
import ShowErrors from "@/components/ShowErrors";
import { required } from "vuelidate/lib/validators";
import { REGISTER_PATIENT } from "@/store/actions.type";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { CONSTANTS } from "@/shared/utils";
import moment from "moment";

export default {
  name: "add-partner",
  components: {
    ShowErrors,
    DatePicker
  },

  data: function() {
    return {
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
          weekdaysMin: ["日", "月", "火", "水", "木", "金", "土"]
        },
        monthBeforeYear: true
      },
      CONSTANTS: null,

      isrend: false,
      userForm: {
        userid: "",
        dob: ""
      }
    };
  },
   /*validation for the Each fields in From */
  validations: {
    userForm: {
      userid: { required },
      dob: { required }
    }
  },
  methods: {
     /* Disable dates in date picker to not select furure dates  */
    notBeforeDate(date) {
      return date > new Date().setDate(new Date().getDate() - 6570);
    },
    gotoCreate() {
      this.$router.push({
        name: "createuserinfo"
      });
    },
     /**
     * Sumbitting the Filled Form
     * Input @param {object} object  this.createPartner object which is filled by the user / in Edit also Using the same function
     * Output @param {boolean}   response Boolean status Api call (true =  success, false = failed)
     */
    success(evt) {
      this.$toast.removeAll();
      this.$v.$touch();
      if (!this.$v.userForm.$invalid) {
        this.isLoading = this.$loading.show({
          loader: "dots",
          color: "#007bff"
        });
        this.userForm["dob"] = moment(this.userForm.dob).format("YYYY/MM/DD");
        this.$store.dispatch(REGISTER_PATIENT, this.userForm).then(data => {
          this.isLoading.hide();
       
          if (data.status) {
            this.$router.push({
              name: "userinfoDetails",
              params: { id: this.userForm.userid, dob: this.userForm.dob }
            });
          } else {
            this.$bvModal.show("modal-Status-create");
          }
        });
      }
    }
  },
  created() {
    this.CONSTANTS = CONSTANTS;
    this.userForm.dob = new Date().setDate(new Date().getDate() - 6560);
  }
};
</script>
<style>
.dragArea {
  min-height: 100px;
  background: #ededed;
  padding: 10px;
}
.list-group-item {
  margin-bottom: 6px;
}
@media (min-width: 770px) {
  .paddingMediaQry {
    margin-top: 19px;
  }

  .textCenterMedia {
    float: "right";
  }
}
</style>
